import { Button } from "@vds/buttons";
import { Row } from '@vds/grids';
import { Modal, ModalBody, ModalTitle } from "@vds/modals";
import { Cell, TableHeader } from "@vds/tables";
import { Body, Title } from "@vds/typography";
import { MarginSpacerM } from "common/components/styleTag";
import { useTranslation } from "react-i18next";
import styled from 'styled-components';

function PlansFirstTwoYearModal(props) {
    const { t } = useTranslation(["plans"]);
    const title = t("plans-first-new.twoYearContractConfirmTitle", { ns: "plans-first-new" });
    const description = t("plans-first-new.twoYearContractConfirmDesc", { ns: "plans-first-new" });

    return (
        <>
        <Modal hideCloseButton={true}
                disableOutsideClick={true}
                onOpenedChange={(e) => {
                    if (!e) {
                        props.closeModal(null)
                    }
                }
                }
                opened={!!props.showModal}
                data-track='close'>
        <ModalTitle>
            <Title size="large" bold={true}>{title}</Title>
        </ModalTitle>
        <ModalBody>
            <Body size="large">{description}</Body>
            <MarginSpacerM />
            <Buttons closeModal={props?.closeModal} continueTwoYearDevice={props.continueTwoYearDevice} />
        </ModalBody>
        </Modal>
        </>
    );
}

const Buttons = (props) => {
    const { t } = useTranslation(["plans-first-new"]);   
    return (
        <ButtonContainer>
             <StyledButton
                onClick={() => {
                    props.closeModal()
                }}
            >
                {t("plans-first-new.buttons.back", { ns: "plans-first-new" })}
            </StyledButton>
            <StyledButton
                use="secondary"
                size="medium"
                onClick={() => { 
                    props.closeModal()
                    props.continueTwoYearDevice() 
                }}
            >
                {t("plans-first-new.buttons.continue", { ns: "plans-first-new" })}
            </StyledButton>
        </ButtonContainer>
    );

}

const ButtonContainer = styled.div`
display:flex;
flex-direction:column;
padding-top:1.5rem;
align-items:center;
gap:1rem;
@media only screen and (min-width:768px){
    flex-direction:row;
}
`;

const StyledButton = styled(Button)`
width:226px;
height:44px;
span {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
@media only screen and (max-width:767px){
    padding:8px 0px;
    width:100%;
}
; `

export default PlansFirstTwoYearModal
